import { capitalizeFirstLetter } from '../../../modules';

/** Title-case each word so nicknames like "OORVI" render as "Oorvi". */
export const formatWalletCardDisplayName = (name?: string): string => {
  if (!name) {
    return '';
  }

  return name
    .split(/\s+/)
    .map(part => capitalizeFirstLetter(part))
    .join(' ');
};
